module.exports = __webpack_public_path__ + "static/circle_of_spores-5002872b70b6a734bcaadacb28f5f53a.png";